import { TAG } from "../constants";
import {
  CreatePatientWeightArgs,
  PatientWeight,
  UpdatePatientWeightArgs,
} from "../types";
import { patientApi } from "./patientApi";

export const weightTrackerApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getLatestWeight: builder.query<PatientWeight, void>({
      query: () => ({
        url: `/api/patient/weight-tracker/latest`,
        method: "GET",
      }),
      providesTags: [TAG.LATEST_WEIGHT],
    }),
    createPatientWeight: builder.mutation<
      PatientWeight,
      CreatePatientWeightArgs
    >({
      query: (body) => ({
        url: `/api/patient/weight-tracker`,
        method: "POST",
        body,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;

        dispatch(
          weightTrackerApi.util.updateQueryData(
            "getLatestWeight",
            undefined,
            () => data,
          ),
        );
      },
      invalidatesTags: [{ type: TAG.PATIENT_WEIGHTS, id: "LIST" }],
    }),
    updatePatientWeight: builder.mutation<
      PatientWeight,
      UpdatePatientWeightArgs
    >({
      query: (body) => ({
        method: "PUT",
        url: "/api/patient/weight-tracker",
        body,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;

        dispatch(
          weightTrackerApi.util.updateQueryData(
            "getLatestWeight",
            undefined,
            () => data,
          ),
        );
      },
    }),
    getPatientWeights: builder.query<PatientWeight[], void>({
      query: () => ({
        method: "GET",
        url: `/api/patient/weight-tracker`,
      }),
      providesTags: [{ type: TAG.PATIENT_WEIGHTS, id: "LIST" }],
    }),
    logPatientWeight: builder.mutation<PatientWeight, CreatePatientWeightArgs>({
      query: (body) => ({
        url: `/api/patient/weight-tracker/log`,
        method: "POST",
        body,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;

        dispatch(
          weightTrackerApi.util.updateQueryData(
            "getLatestWeight",
            undefined,
            () => data,
          ),
        );
      },
      invalidatesTags: [
        { type: TAG.PATIENT_WEIGHTS, id: "LIST" },
        { type: TAG.BATCH },
      ],
    }),
  }),
});

export const {
  useGetLatestWeightQuery,
  useCreatePatientWeightMutation,
  useUpdatePatientWeightMutation,
  useGetPatientWeightsQuery,
  useLogPatientWeightMutation,
} = weightTrackerApi;
